/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAuthorizationStatus.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/authorization-status";

export class AutogenModelAuthorizationStatus<RowType extends ModelRow> extends Endpoint<RowType, RowAuthorizationStatusFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAuthorizationStatus extends ModelRow<RowAuthorizationStatusFields> {
	constructor(values?: Partial<RowAuthorizationStatusFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAuthorizationStatusFields {
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
	status_color: number;
}

